import { IUseTokensStore } from '@/src/store/global';
import { REPEAT } from "@/src/lib/SmartDB/Commons/Constants/images";
import React, { useEffect, useState } from 'react';
import styles from './RefreshAnimated.module.scss';

interface RefreshAnimatedProps {
    tokensStore: IUseTokensStore;
}

const RefreshAnimated: React.FC<RefreshAnimatedProps> = ({ tokensStore }) => {
    //------------
    const [isAnimation, setIsAnimation] = useState(false);
    //------------
    const handleClick = () => {
        tokensStore.refreshPrices({ forceRefresh: true });
        setIsAnimation(true); // Start the animation on click
    };
    //------------
    useEffect(() => {
        //------------
        if (tokensStore.isAddingTokens === false) {
            setIsAnimation(false); // Stop the animation when tokens are no longer being added
        }
    }, [tokensStore.isAddingTokens]);

    return (
        <div className={`${styles.repeat} ${isAnimation ? styles.clicked : ''}`} onClick={handleClick}>
            <svg width="14" height="14" className={styles.icon}>
                <use href={REPEAT}></use>
            </svg>
        </div>
    );
};

export default RefreshAnimated;
